export const TICKET_SYSTEM_LINK = 'https://support.e3dc.com/login.jsp'
